<template>
  <validation-observer ref="editTable" slim>
    <div class="form-container">
      <div class="wrapper">
        <field
          :isEdit="isEdit"
          :detail="detail"
          :options="options"
          @fetchDetailCoalAuxiliary="fetchDetailCoalAuxiliary"
        />
        <br>
      </div>
      <coal-auxiliary-component
        :isEdit="isEdit"
        :detail="detail.details"
        :attachment="attachment"
        @refresh="fetchAttachment"
      />
      <div
        class="d-flex justify-content-end mt-5"
      >
        <b-button
          class="btn-reset mr-2"
          variant="outline-info"
          size="sm"
          @click="onClickBack"
        >
          Back
        </b-button>
        <b-button
          v-if="canEdit && !isEdit && !isSubmitted"
          class="btn-custom"
          variant="info"
          size="sm"
          @click="onClickEdit"
        >
          Edit
        </b-button>
        <b-button
          v-else-if="canEdit && isEdit && !isSubmitted"
          class="btn-custom"
          variant="info"
          size="sm"
          @click="onClickSubmit"
        >
          Submit
        </b-button>
      </div>
    </div>
    <modal-successful :message="text" />
  </validation-observer>
</template>

<script>
import api from '@/api'
import Field from './Field'
import ModalSuccessful from '@/partials/ModalSuccessful'
import coalAuxiliaryComponent from '@/partials/coalAuxiliaryComponent.vue'
import { hasPermission } from '@/utils/permissions'
import { COAL_AUXILLIARY_EDIT } from '@/fixtures'

export default {
  components: {
    Field,
    coalAuxiliaryComponent,
    ModalSuccessful
  },

  data: () => ({
    isEdit: false,
    canEdit: hasPermission(COAL_AUXILLIARY_EDIT),
    attachment: [],
    detail: {
      status: 'Draft',
      company_id: 1,
      contractor_id: 2,
      contract_number: '',
      periode: '',
      details: [
        {
          pit: '',
          volume_item: [
            {
              actual_distance: 0,
              seam: '',
              volume: 0,
              unit_price: 0,
              total_price: 0,
              budget_number_plan_list: [],
              budget_number: {
                cc: null,
                plan: null,
                ac: null,
                sub_ac: null,
                pa: null,
                cc_list: [],
                plan_list: [],
                ac_list: [],
                sub_ac_list: [],
                pa_list: []
              }
            }
          ]
        }
      ]
    },
    options: {
      company: [],
      contractor: []
    },
    budgetDataChange: [],
    cc: [],
    text: '',
    isSubmitted: false
  }),
  async created() {
    this.isEdit = this.$route.meta.isEdit
    this.cc = await api.backupPayment.cc()
    this.fetchCompany()
    this.fetchContractor()
    this.fetchDetailCoalAuxiliary()
    this.fetchAttachment()
  },
  methods: {
    async fetchDetailCoalAuxiliary() {
      const data = await api.coalAuxiliary.get(this.$route.params.id)
      this.detail = data

      if (this.detail.status.toLowerCase() === 'submitted') {
        this.isSubmitted = true
        this.isEdit = false
      }
      await this.convertBudgetNumbers()
    },
    async fetchAttachment() {
      const data = await api.coalAuxiliary.getAttachment(this.$route.params.id)
      this.attachment = data
    },
    onClickBack() {
      localStorage.removeItem('isEdit')
      this.$router.push({ path: '/bup-coal-auxilliary' })
    },
    onClickEdit() {
      localStorage.setItem('isEdit', true)
      this.isEdit = true
      this.$router.push({ path: `/bup-coal-auxilliary/${this.$route.params.id}/edit` })
    },
    async onClickSubmit() {
      const valid = await this.$refs.editTable.validate()
      if (!valid) {
        return false
      }
      const data = this.generatePayload()
      try {
        await api.coalAuxiliary.update(this.$route.params.id, data)
        this.text = 'submitted BUP Coal Auxiliaries'
        this.$bvModal.show('modal-successful')
        setTimeout(() => {
          localStorage.removeItem('isEdit')
          this.onClickBack()
        }, 1500)
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} - ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    async fetchCompany() {
      const data = await api.company.list()
      this.options.company = data
    },
    async fetchContractor() {
      const data = await api.contractor.list()
      this.options.contractor = data
    },
    async convertBudgetNumbers() {
      this.detail.details.map(v => {
        v.volume_item.map(async i => {
          if (i.code) {
            const budgetNumberArray = i.code.split('-')
            i.budget_number_cc = budgetNumberArray[0]
            i.budget_number_plan = budgetNumberArray[1]
            i.budget_number_ac = budgetNumberArray[2]
            i.budget_number_sub_ac = budgetNumberArray[3]
            i.budget_number_pa = budgetNumberArray[4]
            i.budget_number_cc_list = this.cc
            i.budget_number_plan_list = await api.backupPayment.plan({ cc: budgetNumberArray[0] })
            i.budget_number_ac_list = await api.backupPayment.ac({ cc: budgetNumberArray[0], plan: budgetNumberArray[1] })
            i.budget_number_sub_ac_list = await api.backupPayment.subAC({ cc: budgetNumberArray[0], plan: budgetNumberArray[1], ac: budgetNumberArray[2] })
            i.budget_number_pa_list = await api.backupPayment.plan({ cc: budgetNumberArray[0], plan: budgetNumberArray[1], ac: budgetNumberArray[2], sub_ac: budgetNumberArray[3] })
          } else {
            i.budget_number_cc = null
            i.budget_number_plan = null
            i.budget_number_ac = null
            i.budget_number_sub_ac = null
            i.budget_number_pa = null
            i.budget_number_cc_list = this.cc
            i.budget_number_plan_list = []
            i.budget_number_ac_list = []
            i.budget_number_sub_ac_list = []
            i.budget_number_pa_list = []
          }
        })
      })
    },
    generatePayload() {
      const payload = []
      this.detail.details.map(v => {
        v.volume_item.map(i => {
          const code = `${i.budget_number_cc}-${i.budget_number_plan}-${i.budget_number_ac}-${i.budget_number_sub_ac}-${i.budget_number_pa}`
          payload.push({
            id: i.id,
            code: code
          })
        })
      })
      return { data: payload }
    }
  }
}
</script>
